/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState, useEffect, Fragment } from 'react';
import { PrimaryButton, Modal, IconButton, DirectionalHint, Callout, DefaultButton } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import Auth from '../../Auth/Auth';
import axios from 'axios';
import TimeClock from './TimeClock';
import Cookies from 'universal-cookie';
import moment from 'moment'
import differenceInSeconds from 'date-fns/differenceInSeconds'
import ClockinForm from './ClockInForm';
const timeclockrow = () => css`
   border: 1px solid rgba(var(--palette-neutral-20, 234, 234, 234), 1);
    border-radius: 6px;
    padding: 0px 16px;
    display: flex;
    align-items: center;
    cursor:pointer;
    flex:1;
    &:hover{
        box-shadow: 0 3.2px 7.2px 0 var(--callout-shadow-color, rgba(0, 0, 0, 0.132)), 0 0.6px 1.8px 0 var(--callout-shadow-secondary-color, rgba(0, 0, 0, 0.108));
    }
    &.active{
        border-color: rgb(35, 131, 226);
        box-shadow: rgb(35, 131, 226) 0px 0px 0px 2px, rgba(182, 182, 182, 0.25) 0px 8px 12px !important;
    }
`;

function ClockinOptions(props) {
    const [step, setStep] = useState("options");
    const [clockedIn, setClockedIn] = useState(false)
    const [clockedInData, setClockedInData] = useState({})
    const [data, setData] = useState({})
    const [onBreak, setOnBreak] = useState(false)
    const [breakStart, setBreakStart] = useState()
    const [breakDuration, setBreakDuration] = useState()
    const [openTimeClock, setOpenTimeClock] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [availableShifts, setAvailableShifts] = useState(null);
    const [ev, setEv] = React.useState(null);
    let history = useHistory();
    const auth = new Auth();



    useEffect(() => {
        if (breakStart) {
            
            calcBreakTime();
        }
    }, [breakStart]);

    const calcBreakTime = () => {
        debugger
        const time = new moment(moment().format('YYYY-MM-DD') + "T" + breakStart).toDate();
        var x = differenceInSeconds(new Date(), time)
        const time2 = new Date();
        time2.setSeconds(time.getSeconds() + x);
        setBreakDuration(time2)
        setTimeout(calcBreakTime, 1000);
    }

    const { employees, facilityId, user, Settings, breaks, facilityName, timecardClientRoles } = useSelector(state => ({
        Settings: state.appState.clientSettings,
        employees: state.appState.product.facility.employees,
        facilityId: state.appState.product.facility.facilityID,
        user: state.userProfile,
        facilityName: state.appState.product.facility.name,
        breaks: state.appState.breaks,
        timecardClientRoles: state.appState.timecardClientRoles
    }));

    const getClockedInDesktop = () => {
        axios.get(AUTH_CONFIG.API_URL + '/api/Schedules/GetUserClockedInDesktop?userId=' + user.userId).then(response => {
            setClockedInData(response.data)
            let data = response.data;

            if (data && data.endTime == null) {
                setClockedIn(true)
                if (data.onBreak) {
                    setOnBreak(true)
                    setBreakStart(data.onBreak)
                }
            } else {
                setClockedIn(false)
            }
        })
    }

    useEffect(() => {
       
        getClockedInDesktop();
        setData({
            "facilityId": facilityId,
            "facilityName": facilityName,
            "breakTypeId": Settings.breakTypeId,
            "allowUnscheduledClockIns": Settings.allowUnscheduledClockIns,
            "markLate": Settings.markLate,
            "markLateAfter": Settings.markLateAfter,
            "preventEarlyClockIn": Settings.preventEarlyClockIn,
            "preventEarlyClockinMin": Settings.preventEarlyClockinMin,
            "clientsModule": Settings.clientsModule,
            "breaks": breaks
        })

    }, []);

    const openViewShift = (e) => {
        setEv(e.currentTarget)
        setShowOptions(true);
    }

    function generateUUID() { // Public Domain/MIT
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if (d > 0) {//Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    const openFullTimeClock = () => {
        const guid = generateUUID();
        let model = {
            Guid: guid,
            FacilityId: facilityId
        }

        const cookies = new Cookies();
        cookies.set('timeClock', "/time-clock?token=" + guid, { path: '/' });

        axios.post(AUTH_CONFIG.API_URL + '/api/Schedules/TimeClockCreate', model)
            .then((response) => {
                auth.logoutTimeClock(AUTH_CONFIG.CurrentUrl +"/time-clock?token=" + guid);
            });
    }



    const clockInPersonal = () => {
        axios.get(AUTH_CONFIG.API_URL + '/api/Schedules/GetClockInShifts?date=' + moment().format('YYYY-MM-DD') + '&UserId=' + user.userId).then(response => {
            setAvailableShifts(response.data)
            setStep("personal")
        })
    }

    const dismiss = () => {
        setShowOptions(false);
        setStep("options")
    }

    return (
        <div className="prelative">
            <IconButton
                className="notification-icon"
                iconProps={{
                    iconName: 'Clock'
                }}
                onClick={openViewShift}
                styles={{
                    root: { padding: '0 3px', marginRight: '3px', height: '100%', borderRadius: 0 },
                    label: { color: 'rgba(0, 0, 0, 0.87)' },
                    menuIcon: { display: 'none !important' }
                }}
            />
            {clockedIn &&
                <span className="notification-bubble"></span>
            }
            {showOptions &&
                <Callout
                    isBeakVisible={false}
                    gapSpace={0}
                    doNotLayer={false}
                    target={ev}
                    directionalHint={DirectionalHint.bottomRightEdge}
                    onDismiss={() => dismiss()}
                    setInitialFocus={false}
                    styles={{
                        root: {
                            border: '1px solid rgba(var(--palette-neutral-100), 0.18)',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2.4px 5.4px 0px, rgba(0, 0, 0, 0.0807) 0px 1.2px 1.6px 0px',
                            borderRadius: 5, overflow: 'hidden'
                        },
                    }}
                >
                    <div className="displayflex width100 flexcolumn p20 pb30 " style={{ width: 400, minHeight:230 }}>
                        {(step == "options") &&
                            <Fragment>
                                {user.userType != "3" &&
                                    <h3 class="head-l mb10" style={{ fontSize: 17 }}>Choose Your Time Clock</h3>
                                }
                                <div className="displayflex flexcolumn width100">
                                    {user.userType != "3" &&
                                        <div className="displayflex white-to-grey " css={timeclockrow} onClick={() => setStep("shared")}>
                                            <div className="mr15">
                                                <i style={{ fontSize: 30, marginTop: -3 }} class="ms-Icon ms-Icon--Family" aria-hidden="true"></i>
                                            </div>
                                            <div className="flexcolumn" style={{ width: 225, paddingTop: 13, paddingBottom: 13 }}>
                                                <h5 class="head-xs " style={{ marginBottom: 3 }}>Shared Time Clock</h5>
                                                <p className="secondary-medium ">Time clock for employee use.</p>
                                            </div>
                                            <div className="round-arrow-icon ml30">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                                    <g color="var(--token-6889a6d4-a9a4-45fd-a538-dcf976f7e3db, rgb(255, 255, 255))" weight="bold">
                                                        <path d="M204,64V168a12,12,0,0,1-24,0V93L72.49,200.49a12,12,0,0,1-17-17L163,76H88a12,12,0,0,1,0-24H192A12,12,0,0,1,204,64Z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    }
                                    <div className="displayflex white-to-grey mt15" css={timeclockrow} onClick={() => clockInPersonal()}>
                                        <div className="mr15">
                                            <i style={{ fontSize: 30, marginTop: -3 }} class="ms-Icon ms-Icon--Contact" aria-hidden="true"></i>
                                        </div>
                                        <div className="flexcolumn" style={{ width: 225, paddingTop: 13, paddingBottom: 13 }}>
                                            <h5 class="head-xs " style={{ marginBottom: 3 }}>Personal Time Clock</h5>
                                            <p className="secondary-medium ">Time clock for personal use.</p>
                                        </div>
                                        <div className="round-arrow-icon ml30">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                                <g color="var(--token-6889a6d4-a9a4-45fd-a538-dcf976f7e3db, rgb(255, 255, 255))" weight="bold">
                                                    <path d="M204,64V168a12,12,0,0,1-24,0V93L72.49,200.49a12,12,0,0,1-17-17L163,76H88a12,12,0,0,1,0-24H192A12,12,0,0,1,204,64Z"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        }
                        {(step == "personal") &&
                            <div className="pb10 width100 flexcolumn aligncenter">
                                <ClockinForm
                                    userId={user.userId}
                                    data={data}
                                    user={user}
                                    facilityId={facilityId}
                                    close={() => { getClockedInDesktop(); setShowOptions(false) }}
                                    clientsModule={Settings.clientsModule}
                                    timecardClientRoles={timecardClientRoles}
                                />
                            </div>
                        }
                        
                        {(step == "shared") &&
                            <div className="flexcolumn justifycenter aligncenter displayflex">
                                <i style={{ fontSize: 50 }} class="ms-Icon ms-Icon--ReminderTime" aria-hidden="true"></i>
                                <h3 class="head-l" style={{ fontSize: 24 }}>Launch Shared Clock?</h3>
                                <p className="secondary-medium tcenter mb5 mt5">This will log you out of your personal account and a web time clock will be launched. Employees will be able to sign in with their pin or username and password.</p>
                                <PrimaryButton className="mt20" style={{ marginRight: 3 }} onClick={() => openFullTimeClock()} text="Go to time clock" />
                            </div>
                        }
                    </div>
                </Callout>
            }
            <Modal
                isOpen={openTimeClock}
                layerProps={{ eventBubblingEnabled: true }}
                className="time-clock-modal"
                onDismiss={() => openTimeClock(false)}
                isBlocking={false}
                containerClassName="time-clock-container"
            >
                <TimeClock close={() => setOpenTimeClock(false)} />
            </Modal>

            {/*{showShiftNote &&*/}
            {/*    <Modal*/}
            {/*        isOpen={showShiftNote}*/}
            {/*        isBlocking={false}*/}
            {/*        setInitialFocus={false}*/}
            {/*        onDismiss={() => { setShowShiftNote(false); }}*/}
            {/*        className="dark-overlay"*/}
            {/*        styles={{ layer: { zIndex: '3 !important', top: 50, left: 55 } }}*/}
            {/*        firstFocusableSelector="blah"*/}
            {/*        disableFirstFocus={true}*/}
            {/*    >*/}
            {/*        <div className="modal-content request" role="document">*/}
            {/*            <div className="modal-header displayflex">*/}
            {/*                <h3 className="head-m">Shift notes:</h3>*/}
            {/*                <IconButton styles={{ icon: { fontSize: 20 } }} style={{ right: 20 }} className="pabsolute" iconProps={{ iconName: 'Cancel' }} onClick={() => { setShowShiftNote(false) }} />*/}
            {/*            </div>*/}
            {/*            <div className="modal-body">*/}
            {/*                <p className="label-large mb20 mt0" style={{ fontSize: 16 }}>{shiftNote}</p>*/}
            {/*            </div>*/}

            {/*        </div>*/}
            {/*    </Modal>}*/}

        </div>
    );
}

export default ClockinOptions;
